const navBarOffset = 96;

/**
 * A callback for automatically scrolling to an element via element id.
 * @param id id of element to scroll to
 */
const navScrollTo = (id: string) => {
  const element = document.getElementById(id);

  if (element) {
    const sectionTop = element.getBoundingClientRect().top + window.pageYOffset - navBarOffset;
    window.scrollTo({ top: sectionTop, behavior: 'smooth' });
  }
};

export default navScrollTo;
